export const inputMgsErrs = {
  agentId: {
    required: { label: 'input.errors.agent_id.required', useTranslate: true },
    minlength: { label: 'input.errors.agent_id.required', useTranslate: true }
  },
  agentCode: {
    required: { label: 'input.errors.agent_code.required', useTranslate: true },
    minlength: { label: 'input.errors.agent_code.minlength', useTranslate: true }
  },
  password: {
    required: { label: 'input.errors.pw.required', useTranslate: true },
    minlength: { label: 'input.errors.pw.minlength', useTranslate: true },
    pattern: { label: 'input.errors.pw.pattern', useTranslate: true }
  },
  confirmPassword: {
    required: { label: 'input.errors.pw.required', useTranslate: true },
    mustMatch: { label: 'input.errors.pw.must_match', useTranslate: true }
  },
  passCode: {
    required: { label: 'input.errors.pass_code.required', useTranslate: true },
    minlength: { label: 'input.errors.pass_code.minlength', useTranslate: true }
  },
  dateText: {
    required: { label: 'input.errors.date.required', useTranslate: true },
    date: { label: 'input.errors.date.date', useTranslate: true },
    birthday: { label: 'input.errors.date.birthday', useTranslate: true },
  },
  datePickerText: {
    required: { label: 'input.errors.date.required', useTranslate: true },
    date: { label: 'input.errors.date.date_picker', useTranslate: true },
    birthday: { label: 'input.errors.date.birthday', useTranslate: true },
  },
  default: {
    required: { label: 'input.errors.default.required', useTranslate: true },
  },
  addressType: {
    required: { label: 'input.errors.address_type.required', useTranslate: true },
  },
  province: {
    required: { label: 'input.errors.province.required', useTranslate: true },
  },
  familyType: {
    required: { label: 'input.errors.familyType.required', useTranslate: true },
  },
  district: {
    required: { label: 'input.errors.district.required', useTranslate: true },
  },
  subDistrict: {
    required: { label: 'input.errors.sub_district.required', useTranslate: true },
  },
  gender: {
    required: { label: 'input.errors.gender.required', useTranslate: true },
  },
  nationality: {
    required: { label: 'input.errors.default.required', useTranslate: true },
  },
  relationship: {
    required: { label: 'input.errors.relationship.required', useTranslate: true },
  },
  occupation: {
    required: { label: 'input.errors.occupation.required', useTranslate: true },
  },
  tax: {
    required: { label: 'input.errors.tax.required', useTranslate: true },
  },
  titleName: {
    required: { label: 'input.errors.title_name.required', useTranslate: true },
  },
  firstName: {
    required: { label: 'input.errors.first_name.required', useTranslate: true },
  },
  lastName: {
    required: { label: 'input.errors.last_name.required', useTranslate: true },
  },
  userAge: {
    required: { label: 'input.errors.user_age.required', useTranslate: true },
    isJuvernile: {label: 'input.errors.user_age_juv.required', useTranslate: true }
  },
  mobilePhone: {
    required: { label: 'input.errors.mobile_phone.required', useTranslate: true },
    minlength: { label: 'input.errors.mobile_phone.minlength', useTranslate: true },
    maxlength: { label: 'input.errors.mobile_phone.maxlength', useTranslate: true },
    isMap: { label: 'input.errors.mobile_phone.ismap', useTranslate: true}
  },
  currency: {
    required: { label: 'input.errors.currency.required', useTranslate: true },
    min: { label: 'input.errors.currency.min', useTranslate: true },
    max: { label: 'input.errors.currency.max', useTranslate: true }
  },
  insuranceType: {
    required: { label: 'input.errors.insurance_type.required', useTranslate: true }
  },
  insuranceBuyFor: {
    required: { label: 'input.errors.insurance_buy_for.required', useTranslate: true }
  },
  insurancePayer: {
    required: { label: 'input.errors.insurance_payer.required', useTranslate: true }
  },
  email: {
    required: { label: 'input.errors.email.required', useTranslate: true },
    email: { label: 'input.errors.email.pattern', useTranslate: true }
  },
};

import { FormControl, FormGroup } from '@angular/forms';
import { constants } from '../config/constants';

export class inputTextValidator {

  static isJuvernile(userAge: string, occupation: string, assureAge?:number) {
    return (formGroup: FormGroup) => {
      const uage = formGroup.controls[userAge];
      const occ = formGroup.controls[occupation];
        // console.log(occ.value); 1205

      if(assureAge <= constants.ageYouth || uage.value > constants.ageYouth && occ.value == 1205){
        uage.setErrors({ isJuvernile: true });
      }
      return null
    }
  }
//   static isJuvernile(fc: FormControl) {
//     console.log(fc);
//     return ({isJuvernile: true})
//   }
}

